import { Box, TextField } from "@mui/material";
import React, { useRef } from "react";
import OtpInputStyles from "./OtpInput.styles";

interface OTPInputProps {
  onChange: (value: string) => void;
  value: string;
}

function OtpInput({ onChange, value }: OTPInputProps) {
  const classes = OtpInputStyles;
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);

  const handleInputChange =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;

      if (!/^(?:[1-9]|10)?$/.test(newValue)) {
        return;
      }

      let newOtpValue = value;

      if (newValue === "") {
        // If the user clears the input, remove the corresponding digit from the OTP value
        newOtpValue =
          newOtpValue.slice(0, index) + newOtpValue.slice(index + 1);

        // Focus on the previous input field if there is one
        if (inputRefs.current[index - 1]) {
          inputRefs.current[index - 1]?.focus();
        }
      } else {
        // Otherwise, update the corresponding digit in the OTP value
        newOtpValue =
          newOtpValue.slice(0, index) + newValue + newOtpValue.slice(index + 1);

        // Focus on the next input field if there is one
        if (inputRefs.current[index + 1]) {
          inputRefs.current[index + 1]?.focus();
        }
      }

      // Call the onChange callback function with the new OTP value
      onChange(newOtpValue);
    };

  const handleInputFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    event.target.select();
  };

  return (
    <>
      <Box display={"flex"} justifyContent={"space-between"}>
        <TextField
          inputProps={{
            maxLength: 1,
          }}
          variant="outlined"
          value={value.charAt(0)}
          onChange={handleInputChange(0)}
          inputRef={(ref) => (inputRefs.current[0] = ref)}
          sx={classes.inputFeild}
        />
        <TextField
          inputProps={{
            maxLength: 1,
          }}
          variant="outlined"
          value={value.charAt(1)}
          onChange={handleInputChange(1)}
          onFocus={handleInputFocus}
          inputRef={(ref) => (inputRefs.current[1] = ref)}
          sx={classes.inputFeild}
        />
        <TextField
          inputProps={{
            maxLength: 1,
          }}
          variant="outlined"
          value={value.charAt(2)}
          onChange={handleInputChange(2)}
          inputRef={(ref) => (inputRefs.current[2] = ref)}
          sx={classes.inputFeild}
        />
        <TextField
          inputProps={{
            maxLength: 1,
          }}
          variant="outlined"
          value={value.charAt(3)}
          onChange={handleInputChange(3)}
          inputRef={(ref) => (inputRefs.current[3] = ref)}
          sx={classes.inputFeild}
        />
        <TextField
          inputProps={{
            maxLength: 1,
          }}
          variant="outlined"
          value={value.charAt(4)}
          onChange={handleInputChange(4)}
          inputRef={(ref) => (inputRefs.current[4] = ref)}
          sx={classes.inputFeild}
        />
        <TextField
          inputProps={{
            maxLength: 1,
          }}
          variant="outlined"
          value={value.charAt(5)}
          onChange={handleInputChange(5)}
          inputRef={(ref) => (inputRefs.current[5] = ref)}
          sx={classes.inputFeild}
        />
      </Box>
    </>
  );
}

export default OtpInput;
